"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableResponseTapePreviewEligibilityStatusesSchema = exports.CachedEligibilityReceivableSchema = exports.ReceivableResponseTapeSchema = exports.LoanTapeMetadataIterable = exports.DynamicLoanTapeMetadataProperties = exports.StaticLoanTapeMetadataProperties = exports.LoanTapeMetadataPrimitiveProperties = exports.BorrowingBaseReceivableSchema = exports.ConcentrationLimitReceivableSchema = exports.ConcentrationLimitWaiverSchema = exports.ConcentrationLimitReasonSchema = exports.EligibilityReceivableSchema = exports.ValuationReceivableSchema = exports.CreditFacilityReceivableSchema = exports.BorrowingBaseBaseFieldsIterable = exports.BorrowingBaseBaseFieldsSchema = exports.ConcentrationLimitBaseFieldsIterable = exports.ConcentrationLimitBaseFieldsSchema = exports.EligibilityStatusesSchema = exports.EligibilityStatusItemSchema = exports.EligibilityStatusSchema = exports.EligibilityStatusIterable = exports.EligibilityBaseFieldsIterable = exports.EligibilityBaseFieldsSchema = exports.ValuationBaseFieldsIterable = exports.ValuationBaseFieldsSchema = exports.PostProcessedFieldsSchema = exports.DynamicIntermediateFieldsSchema = exports.RequiredIntermediateFieldsSchema = void 0;
const zod_1 = require("zod");
const CreditAgreement_1 = require("../CreditAgreement");
const CustomerProvideValues_1 = require("../CustomerProvideValues");
const Utils_1 = require("../Utils");
const common_1 = require("./common");
// ============================================================================
// ZOD SCHEMAS FOR RECEIVABLE RESPONSE TAPE
// ============================================================================
exports.RequiredIntermediateFieldsSchema = zod_1.z.object({
    assignmentExclusion: common_1.AssignmentExclusionSchema,
    exposure: zod_1.z.number(),
    waiveAllEligibility: zod_1.z.boolean(),
    waiveAllConcentration: zod_1.z.boolean(),
    includeInConcentrationLimitDenominatorIfWaived: zod_1.z.boolean(),
    originalOwnerSlug: zod_1.z.string(),
    normalizedDurationDays: zod_1.z.number().nullable().optional(),
    normalizedisChargedOff: zod_1.z.boolean().nullable().optional(),
    normalizedisDelinquent: zod_1.z.boolean().nullable().optional(),
    normalizedDaysPastDue: zod_1.z.number().nullable().optional(),
    normalizedOriginationDate: zod_1.z.string().nullable().optional(),
    normalizedInitialBalance: zod_1.z.number().nullable().optional(),
});
exports.DynamicIntermediateFieldsSchema = common_1.ReceivableBaseFieldsSchema;
// required fields that will be auto-calculated from base/intermediate fields
exports.PostProcessedFieldsSchema = zod_1.z.object({
    originalOwnerId: zod_1.z.string(),
    normalizedExposure: zod_1.z.number(),
    preassignmentCreditFacilityId: zod_1.z.string().nullable(),
    performingExposure: zod_1.z.number().optional(),
});
exports.ValuationBaseFieldsSchema = zod_1.z.object({
    valuation: zod_1.z.number(),
    valuationRate: zod_1.z.number(),
});
exports.ValuationBaseFieldsIterable = { valuation: 'valuation', valuationRate: 'valuationRate' };
exports.EligibilityBaseFieldsSchema = zod_1.z.object({
    eligibleExposure: zod_1.z.number(),
    isEligible: zod_1.z.boolean(),
    eligibilityKickout: zod_1.z.number(),
});
exports.EligibilityBaseFieldsIterable = {
    eligibleExposure: 'eligibleExposure',
    isEligible: 'isEligible',
    eligibilityKickout: 'eligibilityKickout',
};
exports.EligibilityStatusIterable = ['ELIGIBLE', 'INELIGIBLE', 'INELIGIBLE_WAIVED'];
exports.EligibilityStatusSchema = zod_1.z.enum(exports.EligibilityStatusIterable);
exports.EligibilityStatusItemSchema = zod_1.z.object({
    eligibilityCriteriaKey: zod_1.z.string(),
    eligibilityStatus: exports.EligibilityStatusSchema,
});
exports.EligibilityStatusesSchema = zod_1.z.array(exports.EligibilityStatusItemSchema);
exports.ConcentrationLimitBaseFieldsSchema = zod_1.z.object({
    eligibleExposureLessConcentrationLimitKickouts: zod_1.z.number(),
});
exports.ConcentrationLimitBaseFieldsIterable = {
    eligibleExposureLessConcentrationLimitKickouts: 'eligibleExposureLessConcentrationLimitKickouts',
};
exports.BorrowingBaseBaseFieldsSchema = zod_1.z.object({
    borrowingBaseAmount: zod_1.z.number(),
    advanceRate: zod_1.z.number(),
    advanceRatePath: zod_1.z.string().optional(),
});
exports.BorrowingBaseBaseFieldsIterable = {
    borrowingBaseAmount: 'borrowingBaseAmount',
    advanceRate: 'advanceRate',
    advanceRatePath: 'advanceRatePath',
};
exports.CreditFacilityReceivableSchema = zod_1.z.object({
    loanProductId: zod_1.z.string(),
    finleyReceivableId: zod_1.z.string(),
    externalReceivableId: zod_1.z.string(),
    baseFields: common_1.ReceivableBaseFieldsSchema,
    dynamicIntermediateFields: exports.DynamicIntermediateFieldsSchema,
    requiredIntermediateFields: exports.RequiredIntermediateFieldsSchema,
    postProcessedFields: exports.PostProcessedFieldsSchema,
    assignmentFields: common_1.AssignmentFieldsSchema.nullable(),
});
exports.ValuationReceivableSchema = exports.CreditFacilityReceivableSchema.extend({
    valuationFields: exports.ValuationBaseFieldsSchema,
});
exports.EligibilityReceivableSchema = exports.ValuationReceivableSchema.extend({
    eligibilityStatuses: exports.EligibilityStatusesSchema,
    eligibilityFields: exports.EligibilityBaseFieldsSchema,
});
exports.ConcentrationLimitReasonSchema = zod_1.z.object({
    propertyKey: zod_1.z.string(),
    concentrationLimitKickout: zod_1.z.number(),
});
exports.ConcentrationLimitWaiverSchema = zod_1.z.object({
    propertyKey: zod_1.z.string(),
    waiveReason: zod_1.z.string(),
    waivedAmount: zod_1.z.number().optional(),
});
exports.ConcentrationLimitReceivableSchema = exports.EligibilityReceivableSchema.extend({
    concentrationLimitReasons: zod_1.z.array(exports.ConcentrationLimitReasonSchema),
    concentrationLimitWaivers: zod_1.z.array(exports.ConcentrationLimitWaiverSchema),
    concentrationLimitFields: exports.ConcentrationLimitBaseFieldsSchema,
});
exports.BorrowingBaseReceivableSchema = exports.ConcentrationLimitReceivableSchema.extend({
    borrowingBaseFields: exports.BorrowingBaseBaseFieldsSchema,
});
exports.LoanTapeMetadataPrimitiveProperties = [
    'reportingDate',
    'fileVersion',
    'commitmentAmount',
    'drawRequestAmountForCalendarMonth',
    'principalBalance',
    'lastApprovedOrSubmittedFundingRequestDate',
];
exports.StaticLoanTapeMetadataProperties = [
    ...exports.LoanTapeMetadataPrimitiveProperties,
    'configuredActiveWaivers',
    'previouslyAssigned',
];
exports.DynamicLoanTapeMetadataProperties = [
    'portfolioCovenants',
    CustomerProvideValues_1.CUSTOMER_PROVIDED_VALUES,
];
exports.LoanTapeMetadataIterable = [
    ...exports.StaticLoanTapeMetadataProperties,
    ...exports.DynamicLoanTapeMetadataProperties,
];
exports.ReceivableResponseTapeSchema = zod_1.z.object({
    creditFacilityId: zod_1.z.string(),
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    fileVersion: zod_1.z.number(),
    receivables: zod_1.z.array(exports.BorrowingBaseReceivableSchema),
    concentrationLimitCalculations: zod_1.z.array(CreditAgreement_1.Config.ConcentrationLimit.Calculation.ConcentrationLimitCalculationSchema),
});
exports.CachedEligibilityReceivableSchema = zod_1.z.object({
    loanProductId: zod_1.z.string(),
    finleyReceivableId: zod_1.z.string(),
    eligibilityStatuses: exports.EligibilityStatusesSchema,
    eligibilityFields: exports.EligibilityBaseFieldsSchema,
});
exports.ReceivableResponseTapePreviewEligibilityStatusesSchema = zod_1.z.object({
    receivables: zod_1.z.array(exports.CachedEligibilityReceivableSchema),
});
//# sourceMappingURL=CreditFacility.js.map